import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M95-243q-12-12-12-28-1-17 12-29l224-222q22-23 55-23t56 23l111 111 220-221h-83q-16 0-28-11-11-12-11-29t11-28q12-11 28-11h177q16 0 28 11 12 12 12 29v176q0 16-11 27-11 12-28 12-16 0-28-12-12-11-12-27v-79L596-355q-23 23-56 23t-55-23L373-465 151-243q-12 12-28 12-17 0-28-12Z"/>',
  f: '<path d="M95-243q-12-12-12-28-1-17 12-29l224-222q22-23 55-23t56 23l111 111 220-221h-83q-16 0-28-11-11-12-11-29t11-28q12-11 28-11h177q16 0 28 11 12 12 12 29v176q0 16-11 27-11 12-28 12-16 0-28-12-12-11-12-27v-79L596-355q-23 23-56 23t-55-23L373-465 151-243q-12 12-28 12-17 0-28-12Z"/>',
};

export default data;
